import type {PropertyProps} from 'grapesjs';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';

export interface StyleHeaderProps extends PropertyProps {
  classes?: string;
  text?: string;
}

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType(window.PMW.emails.styles.ID_STYLE_HEADER, {
    /**
     * Creates a style header element
     */
    create(data) {
      const props = data.props as StyleHeaderProps;
      const el = document.createElement('span');
      el.className = window.PMW.emails.styles.ID_STYLE_HEADER;

      if (typeof props.classes === 'string') {
        el.className += ` ${props.classes}`;
      }

      if (typeof props.text === 'string') {
        el.innerHTML += props.text;
      }

      return el;
    },
    emit() {
      // No-op
    },
    update() {
      // No-op
    }
  });
};